import { storableError } from 'util/errors';
import { isPromoCodeUnique } from '../api';

const initialState = {
  validating: false,
  valid: false,
  validateError: null,
};

const VALIDATE_PROMO_CODE_REQUEST = 'app/promoCode/VALIDATE_PROMO_CODE_REQUEST';
const VALIDATE_PROMO_CODE_SUCCESS = 'app/promoCode/VALIDATE_PROMO_CODE_SUCCESS';
const VALIDATE_PROMO_CODE_ERROR = 'app/promoCode/VALIDATE_PROMO_CODE_ERROR';

export default function reducer(state = initialState, action = {}) {
  const { type, payload } = action;
  switch (type) {
    case VALIDATE_PROMO_CODE_REQUEST:
      return { ...state, validating: true, valid: false };
    case VALIDATE_PROMO_CODE_SUCCESS:
      return { ...state, validating: false, valid: payload.valid };
    case VALIDATE_PROMO_CODE_ERROR:
      return { ...state, validating: false, valid: false, validateError: payload };
    default:
      return state;
  }
}

const validateRequest = () => ({ type: VALIDATE_PROMO_CODE_REQUEST });
const validateSuccess = (valid) => ({ type: VALIDATE_PROMO_CODE_SUCCESS, payload: { valid } });
const validateError = (e) => ({ type: VALIDATE_PROMO_CODE_ERROR, payload: e });

export const validatePromoCode =
  ({ promoCode, id }) =>
  async (dispatch) => {
    dispatch(validateRequest());
    try {
      const response = await isPromoCodeUnique({ id, promoCode });
      const isUnique = response.data;
      dispatch(validateSuccess({ valid: isUnique }));
      return isUnique;
    } catch (e) {
      const error = storableError(e);
      dispatch(validateError(error));
      return false;
    }
  };

export const isValid = (state) => state.promoCode.valid;
export const isPromoCodeValidating = (state) => state.promoCode.validating;
export const promoCodeValidateError = (state) => state.promoCode.validateError;
